import createReducer from "../lib/createReducer";
import * as types from "../actions/types";

const sooA = {};
export const DATA_fetch_soonest_ADVANCED = createReducer(sooA, {
  [types.FETCH_TIMESLOTS_SOONEST_ADVANCED](state, action) {
    let newState = sooA;
    newState = Object.assign({}, newState, action.value);
    return newState;
  }
});

const soo = {};
export const DATA_fetch_soonest = createReducer(soo, {
  [types.FETCH_TIMESLOTS_SOONEST](state, action) {
    let newState = soo;
    newState = Object.assign({}, newState, action.value);
    return newState;
  }
});

const soo2 = {};
export const DATA_fetch_soonest_triggered = createReducer(soo2, {
  [types.FETCH_TIMESLOTS_SOONEST_TRIGGER](state, action) {
    let newState = soo2;
    newState = Object.assign({}, newState, action.value);
    return newState;
  }
});

const fetchTimeslotsState = {};
export const dataFetchTimeslots = createReducer(fetchTimeslotsState, {
  [types.FETCH_TIMESLOTS](state, action) {
    let newState = fetchTimeslotsState;
    newState = Object.assign({}, newState, action.value);
    return newState;
  }
});

const fetchAppointmentTimeState = {};
export const dataFetchAppointmentTime = createReducer(
  fetchAppointmentTimeState,
  {
    [types.FETCH_TIME](state, action) {
      let newState = fetchAppointmentTimeState;
      newState = Object.assign({}, newState, action.value);
      return newState;
    }
  }
);

const selectedTimeslotLocation_state = {};
export const selectedTimeslotLocation = createReducer(
  selectedTimeslotLocation_state,
  {
    [types.SET_TIMESLOT_LOCATION](state, action) {
      let newState = selectedTimeslotLocation_state;
      newState = action.value;
      return newState;
    }
  }
);

const tsName = {};
export const selectedFilterLocationName = createReducer(tsName, {
  [types.SET_TIMESLOT_LOCATION_NAME](state, action) {
    let newState = tsName;
    newState = action.value;
    return newState;
  }
});

const fetchAppointmentTimeslotBoolean_state = [];
export const itHasTimeslots = createReducer(
  fetchAppointmentTimeslotBoolean_state,
  {
    [types.FETCH_TIMESLOTS_BOOLEAN](state, action) {
      let newState = fetchAppointmentTimeslotBoolean_state;
      newState = { ...action.value };
      return newState;
    }
  }
);

const a = [];
export const filteredTimeslots = createReducer(a, {
  [types.FILTERED_TIMESLOTS](state, action) {
    let newState = a;
    newState = { ...action.value };
    return newState;
  }
});
